import PropTypes from 'prop-types';
import React from 'react';

import {isIE} from 'common/utils';
import {Marker} from 'common/components/BetterMap';
import dropoffIcon from 'common/components/icons/drop-off.svg';
import pickupIcon from 'common/components/icons/pick-up.svg';

const RideMarker = ({type, ...props}) => (
  <Marker
    animated={isIE()}
    icon={{
      anchor: {x: 24, y: 62},
      size: {width: 48, height: 74},
      url: type === 'pickup' ? pickupIcon : dropoffIcon,
    }}
    {...props}
  />
);

RideMarker.propTypes = {
  type: PropTypes.oneOf(['pickup', 'dropoff']),
};

export default RideMarker;



// WEBPACK FOOTER //
// ./src/ondemand/components/RideMarker.js